export default __webpack_public_path__ + "static/media/WAKINGSHOWER.0f19468b.jpg";